<template>
    <div class="sidebar-item position-relative">
        <transition name="vue-table-loader">
            <div class="vue-table-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key=1 v-if="uiStates.showInput" class="sidebar-selector clearfix">
                <div class="select-container">
                    <input type="text" class="tag-input" v-model="newTag">
                </div>
                <button type="button" v-on:click.prevent="addNewTag(newTag)" class="btn btn-primary">Done</button>
            </div>
            <div key=2 v-else class="sidebar-item-heading" :class="{'no-border' : Object.keys(activeTags).length === 0}">
                <span class="title">{{this.name}}</span>
                <a href="#" v-on:click.prevent="showInput()" class="action-trigger">Add More</a>
            </div>
        </transition>
        <div class="sidebar-item-body" v-if="Object.keys(activeTags).length !== 0">
            <div class="badge badge-primary"  v-for="activeTag in activeTags">
                <span class="copy">{{activeTag.tag_value_en}}</span>
                <a v-on:click.prevent="deleteTag(activeTag)" href="#" class=""><i class="fa fa-minus-circle" aria-hidden="true"></i></a>
            </div>

            <transition name="vue-table-loader">
                <div class="messaging" v-if="message">{{message}}</div>
            </transition>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';
    import InputText from '../../form/form-text.vue';

    Vue.use(VueEvents)

    export default {
        name: 'product-tag-group',
        props: ['groupingName', 'productDetails'],
        components:{
            'input-text': InputText,
        },
        data() {
            return {
                uiStates: {
                    showInput: false,
                    showLoading: false,
                },
                message: "",
                name: this.groupingName,
                product: this.productDetails,
                activeTags: {},
                newTag: null,
                selectableItems: {},
                selectedItem: null,
            }
        },
        mounted() {
            this.getTags();
        },
        created() {

        },
        watch: {
            message: function(query) {
                setTimeout(function() {
                    this.message = "";
                }.bind(this), 3000);
            }
        },
        methods: {
            getTags: function () {
                this.uiStates.showLoading = true;

                axios.get(base_url + '/pimapi/products/'+ this.product.info.id+'/tags', {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.activeTags = response.data.payload.tags;
                    this.uiStates.showLoading = false;
                    this.$parent.$parent.loadedStates['tags'] = true;
                }.bind(this))
                .catch(function (error) {
                    this.message = 'An error has occured!';
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            addNewTag: function (newTag) {
                this.uiStates.showLoading = true;

                axios.post(base_url + '/pimapi/products/'+ this.product.info.id+'/tags', {
                    'tag': newTag,
                })
                .then(function (response) {
                    this.getTags();
                    this.message = response.data.message;
                    this.uiStates.showInput = false;
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.message = 'An error has occured!';
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            deleteTag: function (activeTag) {
                 axios.delete(base_url + '/pimapi/products/'+ this.product.info.id+'/tags/' + activeTag.id, {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.getTags();
                    this.message = response.data.message;
                    this.uiStates.showInput = false;
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.message = 'An error has occured!';
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            showInput: function () {
                this.uiStates.showInput = true;
                this.uiStates.showLoading = false;
            },
        }
    };
</script>

<style scoped lang="scss">
    .vue-table-loader{
        background-color: #fff;
        text-align: right;
        padding-top: 0px;
        padding-right: 4px;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
    .sidebar-item-body{
        padding: 15px 15px;
    }
    .sidebar-item-heading{
        height: 41px;
    }
    .messaging{
        color: #566670;
        position: absolute;
        bottom: 2px;
        right: 5px;
        font-size: 9px;

    }
    .tag-input{
        width: 100%;
        padding: 17px;
        height: 38px;
        border: 0;
    }
    .badge-primary{
        margin-bottom: 5px;
        margin-right: 5px;
        border-color:#02A7CD;
        background:#02A7CD;
        .copy{
            color :white;
        }
        a{
            margin-left: 5px;
            color: white;
        }
    }
</style>